<template>
    <div>
        <div class="table-box" v-if="isShow">
            <div class="search-box">
                <Button type="primary" @click="createConfirm">创建镜像</Button>
                <Button type="primary" @click="getList(currentPage,{channel:1})" >刷新列表</Button>
            </div>
            <Menu mode="horizontal" :theme="'light'" active-name="Private" class="tabs" @on-select="menuChange">
                <MenuItem name="Private">
                    个人镜像
                </MenuItem>
                <MenuItem name="Public">
                    公共镜像
                </MenuItem>
            </Menu>
            <div>
                <component :is="currentPage" :getList="getList" :loading="loading" style=" position: absolute;width:100%"></component>
            </div>
        </div>
        <Modal
                v-model="showDetail"
                title="镜像名称"
                width="700"
        >
            <Table border :columns="detailColumn" :data="detailData"></Table>
        </Modal>

        <!--        选择公有云还是私有云-->
        <select-mcp ref="selectMcp" :returnMcp="create" ></select-mcp>
    </div>
</template>
<script>
    import {mapActions} from 'vuex'
    import Private from "./imagesComponent/private"
    import Public from "./imagesComponent/public"
    import SelectMcp from '../../common/selectMcp'
    export default {
        name:"dataSetList",
        components:{
            Private,
            Public,
            SelectMcp
        },
        data(){
            return {
                loading:false,
                currentPage:'Private',
                showDetail:false,
                create_dataSet:false,
                detailColumn:[
                    {
                        title: 'Python3',
                        key: 'name'
                    }
                ],
                detailData:[
                    {
                        name:"alembic==1.0.11"
                    },
                    {
                        name:"asn1crypto==0.24.0"
                    },
                    {
                        name:"backcall==0.1.0"
                    },
                    {
                        name:"bleach==3.1.0"
                    }
                ]
            }
        },
        methods:{
            ...mapActions({
                getPrivateList:'images/getPrivateImagesList',
                getPublicList:'images/getPublicImagesList',
            }),
            menuChange(name){
                this.currentPage = name
            },
            getList(type,param){
                this.loading = true;
                let params = {
                    data:param,
                    callback:()=>{
                        this.loading = false;
                    },
                    error:()=>{
                        this.loading = false;
                    }
                };
                switch (type) {
                    case 'Private':
                        this.getPrivateList(params);
                        break;
                    case 'Public':
                        this.getPublicList(params);
                        break;
                }
            },
            createConfirm(){
                this.$refs.selectMcp.isshow(true)
            },
            create(mcpId){
                this.$router.push({
                    name: 'createManagImages',
                    params: {mcpid: mcpId}
                })
            }
        },
        computed: {
            isShow(state){
                if(state.create_dataSet == false){
                    return true
                }else{
                    return false
                }
            }
        },
    }
</script>
<style scoped lang="less">
    @import "../../../style/index";
</style>
